// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DigitalpaymentResponseModel {
    static getAttributeTypeMap() {
        return DigitalpaymentResponseModel.attributeTypeMap;
    }
}
DigitalpaymentResponseModel.discriminator = undefined;
DigitalpaymentResponseModel.additionalProperties = false;
DigitalpaymentResponseModel.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=digitalpaymentResponseModel.js.map